const PULSE_ROUTES = {
  People: "/people", // legacy pulse key
  Contact: "/people",
  "Open convs": "/inbox",
  "Drafts pending": "/inbox?filter=draft&select=first",
  "Sent (7d)": "/outreach",
};

export function pulseTilePath(pulseKey) {
  return PULSE_ROUTES[pulseKey] || null;
}

export function pulseTileNavHandler(pulseKey, navigate) {
  const path = pulseTilePath(pulseKey);
  return path ? () => navigate(path) : null;
}
